/**
 * BaseLabel — small uppercase label, typically used above a headline.
 *
 * Props:
 *  label        — the label text to display                          (required)
 *  color        — "primary" (blue) | "secondary" (orange)           (default: "primary")
 *  classProps   — additional Tailwind classes for the <span>         (optional)
 */

type LabelColor = "primary" | "secondary";

type BaseLabelType = {
  label: string;
  color?: LabelColor;
  classProps?: string;
};

const colorMap: Record<LabelColor, string> = {
  primary: "text-primary",
  secondary: "text-secondary",
};

export default function BaseLabel({ label, color = "primary", classProps }: BaseLabelType) {
  return (
    <span
      className={`text-sm uppercase font-semibold tracking-widest font-text pb-2 ${colorMap[color]} ${classProps ?? ""}`}
    >
      {label}
    </span>
  );
}
